import { Link } from 'react-router-dom';
import { categories } from '@/mocks/dramas';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-movie-2-line text-background-50 text-lg"></i>
                </div>
                <span className="text-xl font-bold text-background-50">天天影院</span>
              </div>
              <p className="text-foreground-400 text-sm leading-relaxed">
                天天影视为您整理最新电视剧全集、国产剧全集在线、韩剧全集免费、美剧全集播放与日剧全集资源，追剧无需等待。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">剧集分类</h4>
              <div className="flex flex-col gap-2">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                    className="text-foreground-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">
                  首页
                </Link>
                <Link to="/about" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">
                  关于我们
                </Link>
                <Link to="/about" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">
                  联系我们
                </Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">联系方式</h4>
              <div className="flex flex-col gap-2">
                <span className="text-foreground-400 text-sm">
                  <i className="ri-mail-line mr-2"></i>contact@tiantiancinema.com
                </span>
                <span className="text-foreground-400 text-sm">
                  <i className="ri-phone-line mr-2"></i>400-888-8888
                </span>
                <span className="text-foreground-400 text-sm">
                  <i className="ri-map-pin-line mr-2"></i>北京市朝阳区光华路88号
                </span>
              </div>
            </div>
          </div>

          <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-500 text-sm whitespace-nowrap">
              &copy; {new Date().getFullYear()} 天天影院 tiantiancinema.com 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors whitespace-nowrap" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors whitespace-nowrap" rel="nofollow">
                服务条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}